// 文章类别
const articleType = {
    // '0': '文章',
    // '1': '组图',
    '2': '视频',
    // '3': '专题',
    // '4': '链接',
    // '5': '多标题',
    // '7': '活动',
    // '8': '广告',
    '6': '直播',
    '9': '音频'
}

export {
    articleType
}